import React, {FC, useCallback} from "react";
import {Button, Paper, Box} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SendIcon from "@mui/icons-material/Send";
import {styled} from "@mui/material/styles";
import {SubmitHandler, useForm} from "react-hook-form";
import {useUploadShipmentCsvMutation} from "../../../apis/Log.api.ts";
import {useNavigate} from "react-router";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

type FormInput = {
    file: FileList;
};

type IShipmentUploadProps = {
    id: number;
};

const LogShipmentUpload: FC<IShipmentUploadProps> = ({id}) => {

    const navigate = useNavigate()
    const [uploadShipmentCsvMutation, { isLoading: uploadShipmentCsvLoading }] = useUploadShipmentCsvMutation()
    const uploadShipmentCsv = useCallback(async (upload) => {
        const data = await uploadShipmentCsvMutation(upload).unwrap();
        if(data != null) {
            //if update success
            // navigate('/Dashboard/reports')
        }
    }, [uploadShipmentCsvMutation, navigate])

    const {register, handleSubmit, reset} = useForm<FormInput>();

    const [filename, setFilename] = React.useState(undefined);

    // const onSubmitCsvFile = useCallback((log: Log) => {
    // }, [uploadShipmentCsv, updateLog, setLog, methods])
    const onSubmitHandler: SubmitHandler<FormInput> = (values) => {
        console.log('form', values)

        try {
            // const formData = new FormData();
            // formData.append('file', values.file[0]);
            const inputFile = document.getElementById("fileInput") as HTMLInputElement;
            values.file = inputFile?.files?.item(0) as File;
            uploadShipmentCsv(values);
            reset();
        } catch (error) {
            console.log('upload', error)
        }
    };

    return (
        <Box
            component='form'
            onSubmit={handleSubmit(onSubmitHandler)}
            noValidate
            alignContent="center"
        >
            <Paper>
                <Button component="label" variant="contained" startIcon={<CloudUploadIcon/>}>
                    {filename ? t`Upload file` + filename : t`Select shipment CSV file`}
                    <VisuallyHiddenInput
                        id="fileInput"
                        type="file"
                        accept="application/csv"
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                                setFilename(file.name);
                            }
                        }}
                    />
                </Button>
                {filename && (
                    <Button variant="contained" startIcon={<SendIcon/>} type='submit'>
                        <Trans>Submit</Trans>
                    </Button>
                )}
            </Paper>
        </Box>
    )
}

export default LogShipmentUpload
